import { render, staticRenderFns } from "./RulesOfStreamers.pug?vue&type=template&id=7aef1a62&lang=pug&"
import script from "./RulesOfStreamers.vue?vue&type=script&lang=js&"
export * from "./RulesOfStreamers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports